// Vue
import Vue from "vue";

// App
import { App } from "./App";

// Router
import { router } from "./router";

// Style
import "./scss/app.scss";

// Shared components
import "@mgs/ci2019-common/src/components/shared";

// Destination components
import "@mgs/ci2019-common/src/components/frontend";

// Shared filters
import "@mgs/ci2019-common/src/filters";

// Store
import { Store } from "./store";

// Libraries
import VueI18n from "vue-i18n";
import VeeValidate from "vee-validate";
import { VueMasonryPlugin } from "vue-masonry";
import svg4everybody from "svg4everybody";
import { LanguageService } from "@mgs/ci2019-common/src/services/LanguageService";

// Enums
import { Language } from "@mgs/ci2019-common/src/enums/Language";
import { Icons } from "@mgs/ci2019-common/src/enums/Icons.mercedes";

// CI2019 Components
import { Video } from "@mgs/ci2019-common/src/components/shared/video/Video";
import { SliderItemVideo } from "@mgs/ci2019-common/src/components/shared/slider/item_video/SliderItemVideo";
import { LightboxVideo } from "@mgs/ci2019-common/src/components/shared/lightbox_video/LightboxVideo";
import { Map } from "@mgs/ci2019-common/src/components/shared/map/Map";

// LOCAL Components
import { AppUbersetzungService } from "@mgs/ci2019-common/src/services/AppUbersetzungService";
import { I18NFormatter } from "@mgs/ci2019-common/src/utils/I18NFormatter";

// Make router hooks available to every class component
import "#/router/hooks";

import smoothscroll from "smoothscroll-polyfill";

import lazySizes from "lazysizes";
lazySizes.loadMode = 2;
import LazysizesDirective from "@mgs/ci2019-common/src/utils/LazysizesDirective";
Vue.directive("lazysizes", LazysizesDirective);

// kick off the polyfill!
smoothscroll.polyfill();

// App prefix - Store - Icons
Vue.prototype.$appPrefix = APP_PREFIX;
Vue.prototype.$appTheme = APP_THEME;
Vue.prototype.$store = Store.instance;
Vue.prototype.$icons = Icons;
Vue.prototype.$eventBus = new Vue();

// No production tips
Vue.config.productionTip = false;

svg4everybody();

// Register plugins
Vue.use(VueI18n);
Vue.use(VeeValidate);
Vue.use(VueMasonryPlugin);

// Register global components
Vue.component("MgsVideo", Video);
Vue.component("MgsSliderItemVideo", SliderItemVideo);
Vue.component("MgsLightboxVideo", LightboxVideo);
Vue.component("MgsMap", Map);

window._paq = window._paq || [];

class Cms {
  private static cmsInstance: Cms;
  private vueInstance!: Vue;

  public static get start() {
    if (!Cms.cmsInstance) {
      Cms.cmsInstance = new Cms();
    }

    return this.cmsInstance;
  }

  private constructor() {
    AppUbersetzungService.languageApiUrl = Store.instance.ui.languageApiUrl;
    const i18n = this.getI18N();
    this.createVueInstance(i18n);
  }

  // Bootstrap the language
  private getI18N() {
    const lang = document.documentElement.getAttribute("lang");
    const language =
      Language[
        lang && lang.length === 2 ? lang.toUpperCase() : APP_DEFAULT_LANG
      ];
    Store.instance.ui.setAppCurrentLanguage(language);
    LanguageService.instance.localizeVeeValidate(language);

    let country = document.documentElement.getAttribute("data-country");
    if (country == null || country == "###COUNTRY###") {
      country = "GLOBAL";
    }
    Store.instance.ui.setAppCurrentCountry(country);

    return new VueI18n({
      locale: language.toLowerCase(),
      formatter: new I18NFormatter({}),
      fallbackLocale: language.toLowerCase(),
    });
  }

  private createVueInstance(i18n) {
    this.vueInstance = new Vue({
      router,
      i18n,
      render: (h: any) => h(App),
    }).$mount("#app");
  }
}

Cms.start;
